import * as yup from 'yup';

import { EMAIL, PASSWORD } from '../../../../../../utils/validation';

// SIGN IN
export const loginInitForm = {
  username: '',
  password: '',
};

export const loginSchema = yup.object({
  username: yup.string().email(EMAIL.type).required(EMAIL.required),
  password: yup.string().min(4, PASSWORD.min).required(PASSWORD.required),
});

// PASSWORD CHANGE
export const passwordResetInitForm = {
  username: '',
};

export const passwordResetInitSchema = yup.object({
  username: yup.string().email(EMAIL.type).required(EMAIL.required),
});
